import React, { useCallback } from 'react';
import { Box, Center, Flex, Heading } from '@chakra-ui/react';
import { TerminalCard } from './components/Terminal-card';
import Spinner from '../../components/Spinner';
import { TerminalFilters } from './components/TerminalsFilters';
import { PaginatorFooter } from '../../components/PaginatorFooter';
import { TerminalFiltersQueryParams, useTerminalsFilters } from './hooks/useTerminalsFilters';

export const Terminals = () => {
  const { data, loading, error, setParam, queryParams, nextPage, prevPage, search, resetFilters} = useTerminalsFilters();

  const handleUpdate = useCallback(
    (key: keyof TerminalFiltersQueryParams, value?: string | string[]) => {
      if (value === 'all') {
        search(key, undefined);
        return;
      }
      search(key, value);
    },
    [search]
  );

  if (loading) {
    return <Spinner />;
  }

  return (
    <Flex flexDirection="column" height="100%">
      <Heading as="h2" fontSize="xl" marginBottom="xl">Terminales asociadas</Heading>

      <TerminalFilters onUpdateFilters={handleUpdate} queryParams={queryParams} resetFilters={resetFilters} />

      {loading && <Flex justifyContent="center" width="100%"><Spinner /></Flex>}
      {!!error && <Center color="neutral.800">Error cargando los datos</Center>}

      {!error && data && !loading &&
        <>
          <Box overflowY="auto" paddingX="xl">
            {data.content?.length === 0 && <Center>No se encuentran terminales asociadas</Center>}

            {data.content?.map(terminal => <TerminalCard key={terminal.id} terminal={terminal} />)}
          </Box>

          {data.content?.length > 0 &&
            <Box marginTop="auto" position="sticky" bottom="0">
              <PaginatorFooter
                pageable={data.pageable}
                total_elements={data.total_elements}
                onPreviousPage={prevPage}
                onNextPage={nextPage} />
            </Box>
          }
        </>
      }
    </Flex>
  );
};
